export enum EnvironmentType {
  DEV = 'DEV',
  UAT = 'UAT',
  QA = 'QA',
  PRODUCTION = 'PRODUCTION'
}
